<template>
    <div>
        <v-alert dense outlined type="error" v-if="alertError">
            No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
        </v-alert>            
        
        <v-toolbar title elevation="1">
            <v-toolbar-title class="tituloMaquinaria">{{TituloTabla}}</v-toolbar-title>
            <v-divider vertical class="ml-3"></v-divider>    

            <v-spacer></v-spacer>      
            <v-text-field outlined class=" pr-4"
                label="Buscar Registro"
                v-model="buscarRegistro"
                append-icon="mdi-magnify"
                single-line
                hide-details
            ></v-text-field>
            <v-tooltip bottom color="#0019d8" >
                <template v-slot:activator="{ on }">
                        <v-btn color="#0019d8" rounded dark @click="ObtenerInventarioVehiculosPorSucursal()"
                            v-on="on" class="TamañoLetraBoton mx-2" :disabled="!ActivarMenuTabs"
                        > 
                            <v-icon >fas fa-sync-alt</v-icon> 
                        </v-btn>
                </template>
                <span>Actualizar Tabla</span>
            </v-tooltip>               
            <v-tooltip bottom color="error" >
                <template v-slot:activator="{ on }">
                        <v-btn color="error" rounded dark @click="AbrirModalVisualizarPDFInventario()" 
                            v-on="on" class="TamañoLetraBoton mx-2" :disabled="!ActivarMenuTabs"
                        > 
                            <v-icon >fas fa-file-pdf</v-icon> 
                        </v-btn>
                </template>
                <span>Inventario de Vehículos</span>
            </v-tooltip>                                                     
        </v-toolbar>        
        <v-data-table
            :headers="EncabezadoTablaInventarioSucursal"
            :items="ArrayInventarioVehiculoPorSucursal"
            class="elevation-1"
            :search="buscarRegistro"
            :footer-props="{itemsPerPageText: 'Filas por página'}"                 
            :loading="loading"
            loading-text="Cargando Datos..."                                
        >
            <template v-slot:item.actions="{item}">
                <v-tooltip left color="#3c8dbc">
                    <template v-slot:activator="{ on }">
                        <v-btn small class="ml-2" dark fab color="#3c8dbc" v-on="on" @click="AbrirModalRetornarVehiculoACentral(item)" v-if="permisoCrear">
                            <v-icon small>fas fa-exchange-alt</v-icon>
                        </v-btn>                        
                    </template>
                    <span class="fontButton">Retornar Vehículo</span>
                </v-tooltip>                                                                                            
            </template>
            <template v-slot:no-results>    
                <v-alert type="warning" prominent dense outlined border="left" class="text-xs-center mx-10 mt-2 titulo">
                    Vehículo no existe
                </v-alert>                        
            </template>
            <template v-slot:no-data v-if="ArrayInventarioVehiculoPorSucursal.length === 0">
                <v-alert type="warning" prominent dense outlined border="left" class="text-xs-center mx-10 mt-2 titulo" >
                    No existen Vehículos registrados
                </v-alert>
            </template>                        
        </v-data-table>
        <!-- mostramos el circular progress cuando carguen los datos al mostrar -->
        <v-overlay :value="EstadoCircularProgress">
            <v-progress-circular indeterminate :size="80" :width="10" color="#ffffff"></v-progress-circular> Cargando datos...
        </v-overlay>              
        <MensajeRetornarCentral 
            :dialogoMensajeRetornarCentral="dialogoMensajeRetornarCentral" @CerrarModalRetornarVehiculoACentral="CerrarModalRetornarVehiculoACentral"
            :datosVehiculoMaquinaria="datosVehiculoMaquinaria" :idVehiculo="idVehiculo" @ObtenerInventarioVehiculosPorSucursal="ObtenerInventarioVehiculosPorSucursal"
            :alertError="alertError"
        />
        <ControlladorExcepciones :response="responseStatus"/>
        <VisualizarPDFInventarioGeneral 
            :dialogoVisualizarPDFInventario="dialogoVisualizarPDFInventario" :Titulo="Titulo" :URLPDF="URLPDF"
            @CerrarModalVisualizarPDFInventario="CerrarModalVisualizarPDFInventario"
        />          
    </div>
</template>

<script>
import BotonActualizarTabla from '../../../BotonActualizarTabla'
import MensajeRetornarCentral from '../MensajeRetornarVehiculoMaquinariaCentral'
import ControlladorExcepciones from '../../../../components/ControlandoExcepcionesHTTPS'
import { showMessageError, showMessageSuccess } from '../../../../services/sweetAlert'
import VisualizarPDFInventarioGeneral from '../VisualizarPDFInventario'

export default {
    components:{
        BotonActualizarTabla,
        MensajeRetornarCentral,
        ControlladorExcepciones,
        VisualizarPDFInventarioGeneral,
    },

    props: {
        idSucursal: Number,
        alertError: Boolean,
        permisoCrear: Boolean,
        tab: String,
        TituloTabla: String,
        idProyecto: Number,
        loading: Boolean,
        ArrayInventarioVehiculoPorSucursal: Array,
        ActivarMenuTabs:Boolean,
    },

    data() {
        return {
            buscarRegistro:'',
            EncabezadoTablaInventarioSucursal:[
                {text: 'Código', value: 'codigo', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Placa', value: 'placa', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Color', value: 'color', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Marca Vehículo', value: 'vehiculoMarca.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Tipo Combustible', value: 'tipoCombustible.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Tipo Vehículo', value: 'tipoVehiculo.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},
                {text: 'Fecha Transferencia', value: 'mov_ProyectoVehiculo.fechaAsignacion', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},
                {text: 'Sucursal Origen', value: 'bodega.sucursal.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},
                {text: 'Bodega Origen', value: 'bodega.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},
                {text: 'Acciones', value: 'actions', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],

            // variables para retornar vehiculo a central
            dialogoMensajeRetornarCentral: false,
            datosVehiculoMaquinaria: {
                VehiculoMaquinaria:'',
                codigo:0,
                Tipo:'',
                Marca:'',
                Placa:'',
            },
            idVehiculo:0,            
            responseStatus:[],
            //variables para visualizar pdf de inventario general
            dialogoVisualizarPDFInventario: false,
            Titulo: '',
            URLPDF: '',      
            EstadoCircularProgress:false,    
            
        }
    },

    methods: { 
        ObtenerInventarioVehiculosPorSucursal(){
            this.$emit('ObtenerInventarioVehiculosPorSucursal')
        },
        AbrirModalRetornarVehiculoACentral(datosVehiculo){
            this.datosVehiculoMaquinaria.VehiculoMaquinaria = "Vehículo"
            this.datosVehiculoMaquinaria.codigo = datosVehiculo.codigo
            this.datosVehiculoMaquinaria.Tipo = datosVehiculo.tipoVehiculo.nombre
            this.datosVehiculoMaquinaria.Marca = datosVehiculo.vehiculoMarca.nombre
            this.datosVehiculoMaquinaria.Placa = datosVehiculo.placa
            this.idVehiculo = datosVehiculo.idVehiculo
            this.dialogoMensajeRetornarCentral = true
        },
        CerrarModalRetornarVehiculoACentral(){
            this.dialogoMensajeRetornarCentral = false
        },

        async AbrirModalVisualizarPDFInventario(){
            this.EstadoCircularProgress = true
            this.Titulo = "PDF de inventario de vehículos"
            let datos = {idProyecto: this.idProyecto, idSucursal:this.idSucursal , rubro: 2}
            const response = await this.$store.dispatch('InventarioGeneralPDF', datos)
            if(response.status === 200){
                this.alertError= false
                this.loading = false       
                this.URLPDF= process.env.VUE_APP_BACKEND_HOST + '/Proyecto/pdf/'+this.idProyecto+'/rubro/'+2+'/idSucursal/'+this.idSucursal
                this.dialogoVisualizarPDFInventario = true
                this.EstadoCircularProgress = false
            }else{
                this.ControllerException(response)
                this.EstadoCircularProgress = false
            }                            
        },
        CerrarModalVisualizarPDFInventario(){
            this.URLPDF= ''
            this.dialogoVisualizarPDFInventario = false
        },        
        // controlamos las excepciones de las peticiones al api
        ControllerException(response){
            if(typeof response === 'undefined'){
                this.alertError=true
                this.loading = false
                this.EstadoCircularProgress = false
                this.loadingEliminarTipoVehiculo = false
                return 0
            }else if(response.status === 400){
                showMessageError('Error 400','Petición mala')
                this.loadingEliminarTipoVehiculo = false
                this.loading = false
                this.EstadoCircularProgress = false
            }else if(response.status === 401){
                showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                this.loadingEliminarTipoVehiculo = false
                this.loading = false
                this.EstadoCircularProgress = false
            }else if(response.status === 404){
                showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                this.loadingEliminarTipoVehiculo = false
                this.loading = false
                this.EstadoCircularProgress = false
            }else if(response.status === 500){
                showMessageError('Error 500','Error en el servidor')            
                this.loadingEliminarTipoVehiculo = false
                this.loading = false
                this.EstadoCircularProgress = false
            }
        },        
    },
}
</script>